var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-titleHeader" }, [
    _c(
      "header",
      [
        _c("div", { staticClass: "left" }, [
          _c("em"),
          _c("span", [_vm._v(_vm._s(_vm.text))]),
        ]),
        _vm._t("right"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }